// src/utils/reminderSchedule.js

// --- kind + summarizing helpers (kept identical to your card) ---
export function getKind(r) {
  const raw = (r.recur_kind || r.kind || "").toString().toLowerCase();
  if (raw === "one_off" || raw === "oneoff") return "one_off";
  if (raw === "daily") return "daily";
  if (raw === "weekly") return "weekly";
  return "one_off";
}

function toDate(value) {
  if (!value) return null;
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
}

export function summarize(r) {
  const k = getKind(r);
  const rules = r.rules || {};

  // choose the correct datetime source for a one-off
  if (k === "one_off") {
    const dt = toDate(r.starts_at);
    return dt ? `Einmalig am ${dt.toLocaleString()}` : "Einmalig";
  }

  if (k === "daily") {
    if (rules.times?.length) return `Täglich um ${rules.times.join(", ")}`;
    if (rules.frequency)
      return `Täglich alle ${rules.frequency.every_minutes} Min (${rules.frequency.window_start}–${rules.frequency.window_end})`;
    return "Täglich";
  }

  if (k === "weekly") {
    const days = (rules.days_of_week || []).join(",");
    if (rules.times?.length)
      return `Wöchentlich (${days}) um ${rules.times.join(", ")}`;
    if (rules.frequency)
      return `Wöchentlich (${days}) alle ${rules.frequency.every_minutes} Min (${rules.frequency.window_start}–${rules.frequency.window_end})`;
    return `Wöchentlich (${days || "—"})`;
  }

  return "Erinnerung";
}
